module.exports = __webpack_public_path__ + "img/CheeseFries.9e688bfe.webp";